import * as Types from '../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CardTrackingFragment = {
  __typename: 'CardTracking';
  legacy: {
    __typename: 'LegacyCardTracking';
    presentationTitle: string | null;
    teaserType: string | null;
    woid: string | null;
  } | null;
};

export type ContentTrackingFragment = {
  __typename: 'ContentTracking';
  legacy: {
    __typename: 'LegacyContentTracking';
    structureTitle: string | null;
    structureType: string | null;
    deckId: string | null;
    listId: string | null;
  } | null;
};

export const CardTrackingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardTrackingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CardTracking' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legacy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'presentationTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'teaserType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'woid' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CardTrackingFragment, unknown>;
export const ContentTrackingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentTrackingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentTracking' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legacy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'structureTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'structureType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deckId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentTrackingFragment, unknown>;
